import { useEffect } from "react";
import log from "loglevel";

import { useGetPermissions } from "@chemaxon/terminus-client/ui/services/PermissionService";
import {
  createCheckPermission,
  hasTeamAdminRole,
} from "@chemaxon/terminus-client/ui/services/permissionUtils";
import { useGetCurrentAuthoritites } from "@chemaxon/terminus-client/ui/services/UserInfoService";

export const usePermissions = () => {
  const getPermissionsQueryResult = useGetPermissions();
  const getCurrentAuthoritiesQueryResult = useGetCurrentAuthoritites();

  useEffect(() => {
    if (getPermissionsQueryResult.error) {
      log.error(
        "Failed to load permission info from server.",
        getPermissionsQueryResult.error,
      );
    }
  }, [getPermissionsQueryResult.error]);

  const permissions = getPermissionsQueryResult.data ?? {};
  const authorities = getCurrentAuthoritiesQueryResult.data ?? [];

  const checkPermission = createCheckPermission(permissions);
  const isUserTeamAdmin = hasTeamAdminRole(authorities);

  return {
    queryResult: getPermissionsQueryResult,
    permissions,
    checkPermission,
    isUserTeamAdmin,
  };
};
